import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import { User, StatusEnum } from "@/CodegenTypes";

import { sumBy, first } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import { queries } from "@/apollo";
import { useTranslation } from "@/store/translation";
import { customMoment } from "@/main";

type TtDownlineSummaryRow = {
  userId: User["userId"];
  username: User["username"];
  status: StatusEnum;
  amount: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TtDownlineSummary',
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as {
  userId: User["userId"];
};

const route = useRoute();



const { $t } = useTranslation();
const t = (text: string) => $t(text);

const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
});

const summaryQueryVariables = computed(() => ({
  releaseDate: customMoment(selectedStartReleaseDate.value)
    .startOf("day")
    .toDate(),
  behalfOf: props.userId,
}));

const { result, loading: apolloLoading } = useQuery<{
  downlineTtBetSummary: TtDownlineSummaryRow[];
}>(
  queries.userAndDownlineTtBetSummary,
  summaryQueryVariables,
  {
    enabled: computed(() => !!selectedStartReleaseDate.value && !!props.userId),
    fetchPolicy: "cache-and-network",
  }
);

const downlineSummaryData = computed(() => result.value?.downlineTtBetSummary || []);

const downlineSummaryTotal = computed(() => {
  const data = downlineSummaryData.value;
  return {
    amount: formatDollar(sumBy(data, (row) => row.amount)),
  };
});

return { __sfc: true,route, props, $t, t, selectedStartReleaseDate, summaryQueryVariables, result, apolloLoading, downlineSummaryData, downlineSummaryTotal, formatDollar }
}

})